import React from 'react'

const PickContextMenuSearch = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M27.7 28.4c-.2 0-.3-.1-.4-.2L20.1 21l-.1.1c-2.2 1.9-5 3-7.9 3-6.7 0-12.1-5.4-12.1-12C0 5.4 5.4 0 12.1 0s12.1 5.4 12.1 12.1c0 2.9-1 5.7-3 7.9l-.2.1 7.2 7.2c.2.2.2.6 0 .8-.1.2-.3.3-.5.3zm.3-.9zM12.1 1C5.9 1 1 5.9 1 12.1s5 11.1 11.1 11.1c2.7 0 5.3-1 7.3-2.7l.7-.6.4-.5c1.8-2 2.7-4.6 2.7-7.3C23.1 5.9 18.2 1 12.1 1z" />
  </svg>
)

export default PickContextMenuSearch
